/* eslint-disable camelcase */
import StackAPI from '@/lib/StackAPI'
import SignUpFormValues from '../types/SignUpFormValues'

const PATH = '/partners/affiliates'
const UNKNOWN_ERROR = 'Unknown error.'

type ErrorData = {
  message: string
  path: string[]
}

const buildMessage = (error: ErrorData) => {
  const { path, message } = error
  const fieldName =
    path[0].charAt(0).toUpperCase() + path[0].slice(1).replace(/_/g, ' ')
  return `${fieldName}: ${message}`
}

const createAffiliate = async (
  data: SignUpFormValues,
  recaptchaToken: string
) => {
  const { post } = StackAPI()
  const { terms_of_service, ...restData } = data
  const params = {
    ...restData,
    terms_of_service: terms_of_service ? '1' : '0',
    recaptcha_token: recaptchaToken
  }

  return post({ path: PATH, params })
    .then(({ data }) => ({ data }))
    .catch(({ response }) => {
      const errors = response.data as ErrorData | ErrorData[]

      if (!Array.isArray(errors)) {
        throw new Error((errors as ErrorData)?.message || UNKNOWN_ERROR)
      } else {
        const message = errors.map(buildMessage).join('\n')
        throw new Error(message)
      }
    })
}

export default createAffiliate
